/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Daily_Limit_DescriptionInputs */



/**
* | output |
* | --- |
* | "Your free plan daily limit has been reached. It resets at midnight UTC. Upgrade for unlimited messages." |
*
* @param {Chat_Daily_Limit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_daily_limit_description = /** @type {((inputs?: Chat_Daily_Limit_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Daily_Limit_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein kostenloses tägliches Limit wurde erreicht. Es wird um Mitternacht UTC zurückgesetzt. Upgrade für unbegrenzte Nachrichten.")
	return /** @type {LocalizedString} */ ("Your free plan daily limit has been reached. It resets at midnight UTC. Upgrade for unlimited messages.")
});